export enum ProfileQuestionType {
  Personal = 'personal',
  Professional = 'professional',
}

export enum ProfileQuestionSource {
  Custom = 'custom',
  Library = 'library',
}
